"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsTab = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var FieldsModal_1 = require("./components/FieldsModal");
var ReportList_1 = require("./components/ReportList");
var dispatchers_1 = require("./utils/dispatchers");
var ConfirmationModal_1 = require("./components/ConfirmationModal");
var ExportReport_1 = require("./components/ExportReport");
var errors_1 = require("./utils/errors");
var urlTools_1 = require("./utils/urlTools");
require("./index.scss");
var ReportsTab = function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var _a = React.useState(null), warningModal = _a[0], setWarningModal = _a[1];
    var _b = React.useState(SokReducerTypes.REPORT), listEntryType = _b[0], setListEntryType = _b[1];
    var _c = React.useState([]), selectedReports = _c[0], setSelectedReports = _c[1];
    var reportRemovalState = (0, react_redux_1.useSelector)(function (state) { return state.reports.removedReports; });
    var exportStatusState = (0, react_redux_1.useSelector)(function (state) { return state.reports.exportReport.status; });
    var openReportsModal = function () {
        dispatchers.openFieldsModal('CREATE', SokReducerTypes.REPORT);
        switchView(SokReducerTypes.REPORT);
    };
    var openTemplateModal = function () {
        dispatchers.openFieldsModal('CREATE', SokReducerTypes.TEMPLATE);
        switchView(SokReducerTypes.TEMPLATE);
    };
    var openViewModal = function (uuid, _a) {
        var mode = _a.mode, type = _a.type;
        dispatchers.openFieldsModal(mode, type, uuid);
        switchView(type);
    };
    var switchView = function (type) {
        setSelectedReports([]);
        setListEntryType(type);
        (0, urlTools_1.updateFilterStateUrl)(type, dispatchers.pushUrl);
    };
    var handleRemoveClick = function () {
        var modalTitleLocalizationKey = "management/reports/confirmRemoveTitle".concat(listEntryType === SokReducerTypes.TEMPLATE ? '/templates' : '/reports');
        setWarningModal({
            title: (0, translation_1.getLocalization)(modalTitleLocalizationKey),
            content: selectedReports.map(function (report) { return report.name; }),
            action: function () {
                dispatchers.removeReportsOrTemplates({
                    customerId: props.currentCustomer.id,
                    uuids: selectedReports.map(function (report) { return report.uuid; }),
                    type: listEntryType
                });
            }
        });
    };
    var hideRemovalConfirmModal = function (clearSelection) {
        if (clearSelection === void 0) { clearSelection = true; }
        if (reportRemovalState.status !== 'FETCHING' && warningModal !== null) {
            setWarningModal(null);
        }
        if (clearSelection) {
            setSelectedReports([]);
        }
    };
    var handleRemovalErrors = function () {
        if (reportRemovalState.status === 'FAILED') {
            dispatchers.showToast({
                title: (0, translation_1.getLocalization)('genericWarningConfirmationModal/error'),
                message: (0, translation_1.getLocalization)((0, errors_1.getLocalizedResponseError)(reportRemovalState.error)),
                type: 'FAILURE'
            });
        }
    };
    React.useEffect(function () {
        hideRemovalConfirmModal();
        handleRemovalErrors();
    }, [reportRemovalState]);
    React.useEffect(function () {
        (0, urlTools_1.parseUrlOnReportTabOpen)(setListEntryType, dispatchers.pushUrl);
        return function () {
            dispatchers.clearExportReport();
        };
    }, []);
    var hasOneSelected = selectedReports.length === 1;
    var selectedReport = hasOneSelected ? selectedReports[0].uuid : '';
    return (React.createElement("div", { className: 'reports' },
        React.createElement(sok_ui_1.RequestStatusBox, { status: exportStatusState, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            (0, translation_1.getLocalization)('management/reports/export/status/saving'),
            (0, translation_1.getLocalization)('management/reports/export/status/saved'),
            (0, translation_1.getLocalization)('management/reports/export/status/failed')),
        React.createElement("div", { className: 'buttons' },
            React.createElement(sok_ui_1.Dropdown2, null,
                React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { key: 'filter-icon', className: 'fa-filter' }), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' }), size: 'large', border: 'yellow', color: 'dark-gray', className: 'text-left', text: (0, translation_1.getLocalization)('management/reports/filterDropDown') }),
                React.createElement(sok_ui_1.Dropdown2Menu, null,
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            switchView(SokReducerTypes.REPORT);
                        } },
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('management/reports/filterDropDown/createdReports'), value: listEntryType === SokReducerTypes.REPORT }))),
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () {
                            switchView(SokReducerTypes.TEMPLATE);
                        } },
                        React.createElement("span", null,
                            React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('management/reports/filterDropDown/reportTemplates'), value: listEntryType === SokReducerTypes.TEMPLATE }))))),
            React.createElement(sok_ui_1.Dropdown2, null,
                React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { key: 'add-icon', className: 'fa-plus-circle' }), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' }), size: 'large', color: 'dark-gray', className: 'text-left', text: (0, translation_1.getLocalization)('management/reports/createReportDropDown') }),
                React.createElement(sok_ui_1.Dropdown2Menu, null,
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: openReportsModal }, (0, translation_1.getLocalization)('management/reports/report')),
                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: openTemplateModal }, (0, translation_1.getLocalization)('management/reports/reportTemplate')))),
            listEntryType === SokReducerTypes.TEMPLATE && (React.createElement(ExportReport_1.ExportReport, { disabled: !hasOneSelected, customerId: props.currentCustomer.id, templateUuid: selectedReport, onExport: function () {
                    switchView(SokReducerTypes.REPORT);
                } })),
            React.createElement(sok_ui_1.Button, { disabled: selectedReports.length === 0, iconRight: React.createElement(sok_ui_1.Icon, { key: 'remove-icon', className: 'fa-trash-alt' }), size: 'large', color: 'red', className: 'text-left', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/remove'), onClick: handleRemoveClick })),
        React.createElement(FieldsModal_1.FieldsModal, { listEntryType: listEntryType, currentCustomer: props.currentCustomer }),
        React.createElement(ReportList_1.ReportList, { customer: props.currentCustomer, listEntryType: listEntryType, selectedItems: selectedReports, onInfoButtonClick: openViewModal, onSelectionChange: setSelectedReports }),
        React.createElement(ConfirmationModal_1.ConfirmModal, { isOpen: warningModal !== null, title: (warningModal === null || warningModal === void 0 ? void 0 : warningModal.title) || '', subTitle: (0, translation_1.getLocalization)('management/reports/confirmRemoveContent'), content: (warningModal === null || warningModal === void 0 ? void 0 : warningModal.content) || [], confirmationPending: reportRemovalState.status === 'FETCHING', onConfirm: (warningModal === null || warningModal === void 0 ? void 0 : warningModal.action) || (function () { return void 0; }), onClose: function () { return hideRemovalConfirmModal(false); } })));
};
exports.ReportsTab = ReportsTab;
